import googleIcon from "./../icons/Google.svg";
import facebookIcon from "./../icons/Facebook.svg";
import instagramIcon from "./../icons/InstagramNegative.svg";
import { LinkIcon } from "./LinkIcon";

interface IProps {
  facebookLink?: string;
  instagramLink?: string;
  googleLink?: string;
}

export const SocialLinks = ({
  facebookLink,
  instagramLink,
  googleLink,
}: IProps) => {
  const isVisible = facebookLink || instagramLink || googleLink;

  const socials = (
    <ul className={"flex flex-row gap-8"}>
      <li>
        {facebookLink && (
          <LinkIcon href={facebookLink} src={facebookIcon} alt={"facebook"} />
        )}
      </li>
      {instagramLink && (
        <LinkIcon href={instagramLink} src={instagramIcon} alt={"instagram"} />
      )}
      {googleLink && (
        <LinkIcon href={googleLink} src={googleIcon} alt={"google"} />
      )}
    </ul>
  );

  return <>{isVisible && socials}</>;
};
